import React from "react";
import { Box, FormControlLabel } from "@mui/material";
import JsonEditor, { JSONObject } from "../JsonEditor";
import { defaultSettings, StateProps } from "../state";
import Switch from "@mui/material/Switch";

export interface SettingsModalProps extends StateProps {}

export function SettingsModal(props: SettingsModalProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setState((prevState) => {
      return {
        ...prevState,
        darkMode: event.target.checked,
      };
    });
  };

  return (
    <Box sx={{ height: "100%" }}>
      <JsonEditor
        data={
          {
            ...defaultSettings,
            ...props.state.settings,
          } as unknown as JSONObject
        }
        onChange={(updated) => console.log("Updated JSON:", updated)}
        setState={props.setState}
      ></JsonEditor>
      <FormControlLabel
        value="bottom"
        control={
          <Switch
            checked={props.state.darkMode}
            onChange={handleChange}
            slotProps={{ input: { "aria-label": "controlled" } }}
          />
        }
        label="Dark Mode"
        labelPlacement="bottom"
      />
    </Box>
  );
}
